// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__0pi7Y, .styles_containerHide__KZfnR {
  position: fixed;
  top: 0;
  right: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  z-index: 3600;
  /* background-color: rgba(0,0,0,0.54); */
  opacity: 1;
  transition: all 0.5s;
}

.styles_containerHide__KZfnR {
  opacity: 0;
  transition: all 0.5s;
}

.styles_textStyle__Gqtgo {
  background-color: unset !important;
}

.styles_close__fYlJh {
  /* position:absolute; */
  /* top:10px;
  right:10px; */
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: none;
  /* z-index:300; */
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: unset !important;
  margin-bottom: 10px;
  filter: unset !important;
  opacity: unset !important;
}

.styles_content__tnJPA {
  width: auto;
  min-width: auto;
  height: auto;
  /* -height: 330px; */
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  /* background: #ffffff; */
  box-shadow: 0px 7px 11px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  overflow-y: auto;
  /* box-shadow: 0px 0px 20px 0px #075B52; */
}

.styles_header__ou8Ze {
  width: 100%;
  height: 42px;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #404040;
  /* padding: 20px 20px; */
  box-sizing: border-box;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  display: none;
}

.styles_contentInside__V5jTJ {
  display: flex;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.styles_contentInside__V5jTJ form > button {
  margin-top: auto;
}

.styles_mobileHeader__vOeY5 {
  height: 70px;
  width: 100vw;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.styles_mobileContent__Nu9Ri {
  width: 100vw;
  height: calc(100vh - 70px);
  border-radius: unset;
}

.styles_marginRtl__KpXHR {
  margin-left: 10px;
}

.styles_marginLtr__4aN-l {
  margin-right: 10px;
}

.styles_title__l3fZ6 {
  margin: auto;
  color: #fff;
}

@media only screen and (max-width: 800px) {
  .styles_container__0pi7Y, .styles_containerHide__KZfnR {
    z-index: 3900;
  }
  .styles_contentInside__V5jTJ {
    height: 100% !important;
  }
  .styles_close__fYlJh {
    width: 23px;
    height: 23px;
    /* z-index:300; */
  }
}
@media only screen and (max-width: 500px) {
  .styles_close__fYlJh {
    width: 23px;
    height: 23px;
    /* z-index:300; */
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/CenterModal/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;EACA,UAAA;EACA,oBAAA;AACF;;AACA;EAEE,UAAA;EACA,oBAAA;AACF;;AACA;EACE,kCAAA;AAEF;;AAAA;EACE,uBAAA;EACA;eAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACE,uBAAA;EACA,mBAAA;EACJ,yBAAA;EACA,mBAAA;EACA,wBAAA;EACA,yBAAA;AAGA;;AACA;EAEE,WAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,yBAAA;EACA,2CAAA;EACA,kBAAA;EACA,gBAAA;EACA,0CAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,wBAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,aAAA;AACF;;AAEA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,0BAAA;EACA,oBAAA;AACF;;AACA;EACE,iBAAA;AAEF;;AACA;EACE,kBAAA;AAEF;;AAAA;EACE,YAAA;EACA,WAAA;AAGF;;AADA;EAGE;IACE,aAAA;EAEF;EACA;IACE,uBAAA;EACF;EACA;IACE,WAAA;IACA,YAAA;IACA,iBAAA;EACF;AACF;AACA;EACE;IACE,WAAA;IACA,YAAA;IACA,iBAAA;EACF;AACF","sourcesContent":[".container {\n  position: fixed;\n  top: 0;\n  right: 0;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  z-index: 3600;\n  /* background-color: rgba(0,0,0,0.54); */\n  opacity:1;\n  transition:all 0.5s;\n}\n.containerHide{\n  @extend .container;\n  opacity:0;\n  transition:all 0.5s;\n}\n.textStyle{\n  background-color: unset !important;\n}\n.close{\n  /* position:absolute; */\n  /* top:10px;\n  right:10px; */\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  border: none;\n  /* z-index:300; */\n  cursor:pointer;\n  display: flex;\n    justify-content: center;\n    align-items: center;\npadding:unset !important;\nmargin-bottom:10px;\nfilter: unset !important;\nopacity: unset !important;\n  \n}\n\n.content {\n\n  width: auto;\n  min-width: auto;\n  height: auto;\n  /* -height: 330px; */\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  /* background: #ffffff; */\n  box-shadow: 0px 7px 11px rgba(0, 0, 0, 0.3);\n  border-radius: 8px;\n  overflow-y:auto;\n  /* box-shadow: 0px 0px 20px 0px #075B52; */\n}\n\n.header {\n  width: 100%;\n  height: 42px;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #404040;\n  /* padding: 20px 20px; */\n  box-sizing: border-box;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  display:none;\n}\n\n.contentInside {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  display:flex;\n  flex-direction:column;\n  justify-content: flex-start;\n  align-items:center;\n}\n\n.contentInside form>button {\n  margin-top: auto;\n}\n\n.mobileHeader{\n  height: 70px;\n  width:100vw;\n  display:flex;\n  justify-content: flex-start;\n  align-items:center;\n  \n}\n.mobileContent{\n  width:100vw;\n  height:calc(100vh - 70px);\n  border-radius:unset;\n}\n.marginRtl {\n  margin-left: 10px;\n}\n\n.marginLtr {\n  margin-right: 10px;\n}\n.title{\n  margin:auto;\n  color:#fff;\n}\n@media only screen and (max-width: 800px) {\n\n\n  .container {\n    z-index: 3900;\n  }\n\n  .contentInside {\n    height: 100% !important;\n  }\n  .close{\n    width:23px;\n    height:23px;\n    /* z-index:300; */\n  }\n}\n@media only screen and (max-width: 500px) {\n  .close{\n    width:23px;\n    height:23px;\n    /* z-index:300; */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__0pi7Y`,
	"containerHide": `styles_containerHide__KZfnR`,
	"textStyle": `styles_textStyle__Gqtgo`,
	"close": `styles_close__fYlJh`,
	"content": `styles_content__tnJPA`,
	"header": `styles_header__ou8Ze`,
	"contentInside": `styles_contentInside__V5jTJ`,
	"mobileHeader": `styles_mobileHeader__vOeY5`,
	"mobileContent": `styles_mobileContent__Nu9Ri`,
	"marginRtl": `styles_marginRtl__KpXHR`,
	"marginLtr": `styles_marginLtr__4aN-l`,
	"title": `styles_title__l3fZ6`
};
export default ___CSS_LOADER_EXPORT___;
